import { createLazyFileRoute } from "@tanstack/react-router";

import { EditPrinterPage } from "@/features/admin/routes/PrinterEdit";

export const Route = createLazyFileRoute("/_auth/admin/printers/$id/edit")({
  component: () => {
    const params = Route.useParams();
    return <EditPrinterPage {...params} />;
  },
});
